import { Button } from '@/components/ui';
import { cn } from '@/utils/cn';

interface UserNewStepperProps {
  currentStep: number;
  onStepChange: (step: number) => void;
}

const STEPS = [
  { id: 1, label: 'Thông tin cơ bản',      icon: 'ri-user-line' },
  { id: 2, label: 'Công việc & Học vấn',   icon: 'ri-briefcase-line' },
  { id: 3, label: 'Liên hệ & Xác nhận',    icon: 'ri-shield-check-line' },
];

export function UserNewStepper({ currentStep, onStepChange }: UserNewStepperProps) {
  return (
    <div className="flex items-center gap-0 border-b border-slate-100 mb-8 overflow-x-auto scrollbar-hide">
      {STEPS.map((step, idx) => {
        const isDone    = currentStep > step.id;
        const isActive  = currentStep === step.id;
        return (
          <button
            key={step.id}
            onClick={() => onStepChange(step.id)}
            className={cn(
              'flex items-center gap-2 pb-4 px-4 h-auto rounded-none sm:text-sm text-xs transition-all relative whitespace-nowrap border-b-2 bg-transparent',
              isActive  && 'text-emerald-700 border-emerald-700',
              isDone    && 'text-emerald-500 border-emerald-200',
              !isActive && !isDone && 'text-slate-400 border-transparent hover:text-slate-600',
            )}
          >
            <span className={cn(
              'w-5 h-5 rounded-full flex items-center justify-center text-xs transition-all',
              isActive && 'bg-emerald-700 text-white',
              isDone   && 'bg-emerald-100 text-emerald-600',
              !isActive && !isDone && 'bg-slate-100 text-slate-400',
            )}>
              {isDone ? <i className="ri-check-line text-xs" /> : step.id}
            </span>
            <span className={isActive ? 'font-medium' : ''}>{step.label}</span>

            {/* Separator */}
            {idx < STEPS.length - 1 && (
              <i className="ri-arrow-right-s-line text-slate-200 ml-2" />
            )}
          </button>
        );
      })}
    </div>
  );
}
